import React, { useState } from "react";
import FileUploader from "../../../../../reusableComponents/FileUploader2";
import { Col, Container, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import ButtonWrapper from "../../../../../components/Button";

const OldLandUsePlinth = ({ t, formData, handleSubTabChange, handleTabChange, isEmployee, isApproved }) => {
  const [showError, setShowError] = useState(false);
  const { handleSubmit, control } = useForm();
  const { documents } = useSelector((state) => state.formMT);

  console.log("formData1111212", formData);

  const validateRequiredDocuments = (documents = []) => {
    const requiredTypes = ["drawingPdf", "approvalLetter"];

    return requiredTypes.every((type) => documents.some((doc) => doc.documentType === type));
  };

  const onSubmit = (data) => {
    const isValid = validateRequiredDocuments(documents);
    if (!isValid) {
      setShowError(true);
      return;
    } else {
      data = {
        ...formData,
        documents: documents,
      };
      console.log("data", data, documents);
      handleTabChange(1, data);
    }
  };

  return (
    <section className="groupContainer3">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Document")}</h2>
          </div>
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col className="custom-upload new-custom-uploader">
                <FileUploader
                  isMandatory
                  label={t("Drawing PDF")}
                  control={control}
                  name="drawingPdf"
                  showError={showError}
                  maxFiles={1}
                  validationMsg="(pdf file only and Max file Size 30 MB)"
                  required
                />
              </Col>
              <Col className="custom-upload new-custom-uploader">
                <FileUploader
                  isMandatory
                  label={t("Approval Letter")}
                  control={control}
                  maxFiles={1}
                  showError={showError}
                  name="approvalLetter"
                  validationMsg="(pdf file only and Max file Size 30 MB)"
                  required
                />
              </Col>
            </Row>
          </Container>
          <div className="footerContainer2">
            {!isEmployee && !isApproved && (
              <div className="buttonWrapper">
                <ButtonWrapper
                  variant="contained"
                  color="error"
                  size="medium"
                  label="Prev"
                  sx={{ backgroundColor: "#CCC", marginRight: "4px" }}
                  onClick={() => handleSubTabChange(2)}
                />
                <ButtonWrapper
                  variant="contained"
                  color="success"
                  size="medium"
                  label="Save"
                  type="submit"
                  sx={{ backgroundColor: "#000", marginRight: "4px" }}
                />
              </div>
            )}
          </div>
        </div>
      </form>
    </section>
  );
};

export default OldLandUsePlinth;
